const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-zinc-900/10 bg-[#F0F2F5] py-6">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="mx-10 flex items-center gap-10 whitespace-nowrap">
            <span className="font-heading text-3xl font-semibold uppercase tracking-[0.15em] text-zinc-300 sm:text-4xl">{item}</span>
            <span className="text-cyan-600">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
